export const coffeeBeans = [{
    "id": "1",
    "product": "CoffeeBeans",
    "image": "images/coffeeBeans/img-1.jpg",
    "brand": "BODUM",
    "price": "499.99",
},
{
    "id": "2",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-2.jpg",
    "brand": "ONYXs",
    "price": "899.00", 
},
{
    "id": "3",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-3.jpg",
    "brand": "DOCKER ",
    "price": "799.50",
},
{
    "id": "4",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-4.jpg",
    "brand": "EARLY BIRD",
    "price": "349.99",
},
{
    "id": "5",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-5.jpg",
    "brand": "HAPPY COFFEE",
    "price": "599.00",
},
{
    "id": "6",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-6.jpg",
    "brand": "BOX COFFEE",
    "price": "299.50",
},
{
    "id": "7",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-7.jpg",
    "brand": "STARBUCKS",
    "price": "199.99",
},
{
    "id": "8",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-8.jpg",
    "brand": "COFFEE BEE",
    "price": "89.00",
},
{
    "id": "9",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-9.jpg",
    "brand": "CAUSE ROAST",
    "price": "599.99",
},
{
    "id": "10",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-10.jpg",
    "brand": "CORTADO",
    "price": "999.00",
},
{
    "id": "11",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-11.jpg",
    "brand": "NESCAFE",
    "price": "149.50",
},
{
    "id": "12",
    "product": "CoffeeBeans",
    "image": "images/CoffeeBeans/img-12.jpg",
    "brand": "YOSEMITE",
    "price": "249.00",
}
]